import { createSelector } from '@ngrx/store';

import { AffectedCamerasStatus } from '@live/pages/live-ai-models-and-presets-page/tabs/live-presets-tab/components/apply-preset/interfaces';
import { getModelTypeDisplayName } from '@live/live.utils';

import { toLocaleMonthFormattedString } from '@common/modules/utils/time';

import { selectLiveEdgeState } from './live-edge-base.selectors';

export const selectPresetsState = createSelector(selectLiveEdgeState, state => state.presets);

export const selectPresetsEntities = createSelector(selectPresetsState, state => state.entities);

export const selectPresets = createSelector(selectPresetsEntities, entities => {
  return Object.values(entities).sort((a, b) => new Date(b.lastUpdateTime).getTime() - new Date(a.lastUpdateTime).getTime());
});

export const getPresetsDetails = createSelector(selectPresets, presets => {
  return presets.map(preset => {
    return {
      id: preset.id,
      name: preset.name,
      affectedCamerasCount: preset.affectedCamerasCount,
      affectedCamerasStatus: preset.affectedCamerasStatus as AffectedCamerasStatus,
      lastModified: toLocaleMonthFormattedString(new Date(preset.lastUpdateTime)),
      includedInsights: preset.insightTypes.map(insight => `${insight.insightName} - ${getModelTypeDisplayName(insight.modelType)}`)
    };
  });
});

export const selectIsPresetsLoaded = createSelector(selectPresetsState, state => state.loaded);

export const getPresetError = createSelector(selectPresetsState, state => state.error);

export const selectPresetsPageTab = createSelector(selectPresetsState, state => state.page.selectedTab);

export const selectPreset = id => createSelector(selectPresetsEntities, entities => entities[id]);

export const selectPresetName = id => createSelector(selectPresetsEntities, entities => entities[id]?.name);

export const selectPresetInsightTypes = id => createSelector(selectPresetsEntities, entities => entities[id]?.insightTypes);

export const selectIsPresetLoaded = id => createSelector(selectPreset(id), preset => preset?.isLoaded);

export const selectAffectedCamerasCount = id => createSelector(selectPreset(id), preset => preset.affectedCamerasCount);

export const selectAffectedCamerasStatus = id => createSelector(selectPreset(id), preset => preset.affectedCamerasStatus);

export const selectTotalNumberOfPresets = createSelector(selectPresetsState, state => state.nextPage?.totalCount);
export const selectIsSaving = createSelector(selectPresetsState, state => state.isSaving);
export const selectPresetsNextPage = createSelector(selectPresetsState, state => state.nextPage);
